import * as THREE from 'three';
import floaty from './assets/floaty4.jpg'
function Floaties(scale,coverage) {
  // FLoaties
    scale= scale || 3;
    coverage = coverage || 1
    var fall=10;
    var particleGeom = new THREE.Geometry();
    var particleMaterial = new THREE.PointsMaterial({
      color: 0x888888,
      size: 4*scale,
      map: new THREE.TextureLoader().load(floaty),
      transparent: true,
      blending: THREE.AdditiveBlending,
    });
    let particleCount = 10000*coverage;
    var offsets = new Float32Array( particleCount );
    let particleDistance = 5000*scale;
    for (var i=0; i<particleCount; i++) {
      offsets[i]=Math.random() - 0.5;
      let posX = (Math.random() - 0.5) * particleDistance;
      let posY = (Math.random() - 1) * 1000;
      let posZ = (Math.random() - 0.5) * particleDistance;
      let particle = new THREE.Vector3(posX, posY, posZ);
      particleGeom.vertices.push(particle);
    }
    let particleSys = new THREE.Points(particleGeom, particleMaterial);
    particleSys.name = 'particleSys';
    this.particles=particleSys
    
    //
    this.setFall = function(val){
      //alert("SET FALL "+val)
      fall=val
    }
    this.update = function (time) {  
			var count=0
			particleSys.geometry.vertices.forEach(particle => {
				var dX, dY, dZ;
				dX = 0 //Math.sin(time*particle.x*.001)*10 ;
        dY = Math.sin(time*.1+offsets[count])*.1*scale+fall
       
        dZ =  0 //Math.random() * 0; //.02 - .01;
        //if(count==1){
        //  console.log(particle)
        //}
				count++
        particle.add(new THREE.Vector3(dX, dY, dZ));

        if(particle.y>1000){
          particle.y-=2000-Math.random()*1000
        }
        
			})
			particleSys.geometry.verticesNeedUpdate = true;
     }
	return this
};

export { Floaties }